import { render, staticRenderFns } from "./SettingsDECP.vue?vue&type=template&id=86012990&"
import script from "./SettingsDECP.vue?vue&type=script&lang=js&"
export * from "./SettingsDECP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports